enum CustomCaseQuantity {
    US = 'customCaseQuantity-us',
    CA = 'customCaseQuantity-ca',
}

export { CustomCaseQuantity };
